import {default as clean} from './clean';

export const commands = {clean};
